<template>
  <base-content>
    <template v-slot:top>
      <hero-header centered heading="Please help us to verify your identity" />
    </template>
    <template v-if="loaded">
      <base-card>
        <template v-slot:body-top>
          <template v-if="!$auth.user.hasPassedAppropriateness">
            <base-card-title>Appropriateness test not passed</base-card-title>
          </template>
          <template v-else>
            <base-card-title>Please provide the following documents</base-card-title>
          </template>
        </template>
        <template v-if="!$auth.user.hasPassedAppropriateness">
          <p class="mb-0">
            You have not passed your appropriateness test yet where we first establish your suitability for investing with us,
            please <router-link :to="{ name: 'appropriateness' }">take the appropriateness test</router-link> before providing your identity.
          </p>
        </template>
        <template v-else>
          <div class="row align-items-center mb-3">
            <div class="col-sm-6">
              <ul>
                <li>Copy passport or photo driving licence </li>
              </ul>
              <p class="ml-4 text-muted">AND</p>
              <ul>
                <li>A recent proof of address dated no later than 3 months ago:</li>
                <li>bank statement (not a credit card);</li>
                <li>utility bill; or</li>
                <li>government document.</li>
              </ul>
              <p class="mb-0">
                It may take up to 48 hours to review your documents, if there are any issues and/or you would like to get in touch, please visit the
                <router-link :to="{ name: 'support-centre' }">support centre</router-link>.
              </p>
            </div>
            <div class="col-sm-6">
              <template v-if="documents.length">
                <base-table class="mt-4 mt-sm-0">
                  <thead>
                    <tr>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Comment</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(document, key) in documents" :key="key">
                      <td>{{ $_.get(types, document.type) }}</td>
                      <td :class="{ 'text-success': document.status === '2' }">
                        {{ $_.get(statuses, document.status) }}
                      </td>
                      <td>{{ document.comment }}</td>
                    </tr>
                  </tbody>
                </base-table>
              </template>
              <template v-else>
                <p class="text-center">
                  You haven't uploaded any documents yet.
                </p>
              </template>
              <kyc-document-submit @submitted="afterSubmit" />
              <div class="text-center mt-4">
                <base-button icon-right="cloud-upload-alt" modal="#kycDocumentSubmit" secondary>
                  Upload Document
                </base-button>
              </div>
            </div>
          </div>
        </template>
      </base-card>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'
import KycDocumentSubmit from '@/components/KycDocumentSubmit.vue'

export default {
  components: {
    HeroHeader,
    KycDocumentSubmit
  },

  metaInfo: {
    title: 'Verify Identity'
  },

  data: () => ({
    loaded: false
  }),

  async created () {
    await Promise.all([
      this.getDocumentStatuses(),
      this.getDocumentTypes()
    ])
    await this.load()

    this.loaded = true
  },

  computed: {
    ...mapState({
      documents: store => store.core.kyc.entities,
      profile: store => store.core.userProfile.entity,
      statuses: store => store.core.kyc.statuses,
      types: store => store.core.kyc.types
    })
  },

  methods: {
    afterSubmit () {
      this.load()

      this.$modal.close('#kycDocumentSubmit')
    },

    async load () {
      await this.getKycDocuments({
        query: {
          user: this.$auth.user._id
        }
      })
    },

    ...mapActions({
      getDocumentStatuses: 'core/kyc/statuses',
      getDocumentTypes: 'core/kyc/types',
      getKycDocuments: 'core/kyc/all'
    })
  }
}
</script>
